<template>
  <v-select class="plain-dropdown" ref="select" :value="selected" :components="{OpenIndicator}"  @input="onChange"
            :searchable="false" :clearable ="false" :options="options" >
    <template slot="selected-option" slot-scope="option">
      <span class="label" :class="variant">{{ option.label }}</span>
    </template>
    <template slot="option" slot-scope="option">
      <span class="label" :class="option.label === selected ? variant : ''">{{ option.label }}</span>
    </template>
  </v-select>
</template>

<script>
import Vue from 'vue';
import vSelect from 'vue-select';

Vue.component('v-select', vSelect);

export default {
  name: 'Dropdown',
  props: {
    firstSelected: {
      type: String,
      require: true,
    },
    options: {
      type: Array,
      require: true,
    },
    onSelect: {
      type: Function,
      require: true,
    },
    variant: {
      type: String,
      required: false,
      default: 'danger',
      validator: val => ['danger', 'success', 'fixed'].includes(val),
    },
  },
  data() {
    return {
      selected: this.firstSelected,
      OpenIndicator: {
        render: createElement => {
          const arrow = createElement('span', { class: { fa: true, 'fa-caret-left': true } });
          return createElement('div', [arrow]);
        },
      },
    };
  },
  methods: {
    onChange(value) {
      this.selected = value;
      this.onSelect(value);
    },
  },
};
</script>

<style lang="scss">
  @import '../scss/riseup-colors';

  .plain-dropdown {
    position: relative;
    font-family: SimplerPro;
    color: $riseup_black;
    font-size: 16px;
    line-height: 1.5;
    direction: rtl;
    font-weight: bold;

    .icon {
      font-size: 14px;
      margin-left: 12px;
    }

    .vs__selected {
      margin-right: 4px;
      margin-bottom: 2px;
    }

    .label {
      font-size: 16px;
      &.danger {
        color: $riseup_danger_red;
      }
      &.fixed {
        color: $riseup_red;
      }
      &.success {
        color: $riseup_green;
      }
    }

    .vs__dropdown-toggle {
      border-radius: 1px;
      border: transparent;
      box-shadow: 2px 2px 8px 0 $riseup_gray_1;
      padding: 0;
      height: 40px;
      display: flex;
      flex-direction: row;
      align-items: center;
      color: $riseup_black;
      background-color: $riseup_white;
      z-index: 1000;
      position: sticky;

      .vs__actions {
        padding: 0px 0px 0px 10px;

        .vs__open-indicator {
          display: flex;
          font-size: 20px;
        }
      }

    }

    .vs__dropdown-menu {
      position: absolute;
      border-radius: 1px;
      border: transparent;
      box-shadow: 2px 2px 8px 0 $riseup_gray_1;
      padding: 0px;
      z-index: 1;
      top: 100%;
    }

    .vs__dropdown-option {
      height: 24px;
      font-size: 14px;
      font-weight: normal;
      color: $riseup_black;
      padding: 0px 12px;
      display: flex;
      align-items: center;

      &.vs__dropdown-option--highlight  {
        background: #f6f6f6;
      }

      &.vs__dropdown-option--selected  {
        background: #f6f6f6;
      }
    }

    &.vs--open {
      .vs__open-indicator {
        transform: rotate(270deg) scale(1);
      }

      .vs__selected {
        opacity: 1;
      }
    }
  }
</style>
